import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import type { InAppNotification } from 'types/InAppNotification';

dayjs.extend(utc);

const DAYS_IN_RECENT_WEEK = 7;

export const NOTIFICATION_GROUP = {
  Today: 'today',
  ThisWeek: 'thisWeek',
  Older: 'older',
} as const;

export type NotificationGroupKey =
  (typeof NOTIFICATION_GROUP)[keyof typeof NOTIFICATION_GROUP];

export type NotificationGroup = {
  key: NotificationGroupKey;
  notifications: InAppNotification[];
};

export const NOTIFICATION_GROUP_LABEL: Record<NotificationGroupKey, string> = {
  today: 'notifications.group.today',
  thisWeek: 'notifications.group.thisWeek',
  older: 'notifications.group.older',
};

const GROUP_ORDER: NotificationGroupKey[] = [
  NOTIFICATION_GROUP.Today,
  NOTIFICATION_GROUP.ThisWeek,
  NOTIFICATION_GROUP.Older,
];

function resolveGroupKey(createdAt: string): NotificationGroupKey {
  const createdAtLocal = dayjs.utc(createdAt).local();
  const startOfToday = dayjs().startOf('day');

  if (createdAtLocal.isAfter(startOfToday)) {
    return NOTIFICATION_GROUP.Today;
  }

  if (
    createdAtLocal.isAfter(startOfToday.subtract(DAYS_IN_RECENT_WEEK, 'day'))
  ) {
    return NOTIFICATION_GROUP.ThisWeek;
  }

  return NOTIFICATION_GROUP.Older;
}

export function groupNotificationsByAge(
  notifications: InAppNotification[],
): NotificationGroup[] {
  return GROUP_ORDER.map((key) => ({
    key,
    notifications: notifications.filter(
      (notification) => resolveGroupKey(notification.created_at) === key,
    ),
  })).filter((group) => group.notifications.length > 0);
}
